import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { StoreSpecialWorkingTime } from '../../../classes/models/store/StoreSpecialWorkingTime';
import {
  AddStoreSpecialWorkingHoursRequest,
  EditStoreSpecialWorkingHoursRequest
} from '../../../interfaces/request/StoreRequests';

/**
 * This service communicates with backend to handle store special working time data management.
 */
@Injectable({
  providedIn: 'root'
})
export class StoreSpecialWorkingTimeService {
  private http = inject(HttpClient);

  url = environment.apiUrl + '/stores';

  /**
   * Adds a new special working time record for the given store.
   * @param storeId an identifier of a store.
   * @param specialWorkingTime special store working times.
   */
  addSpecialStoreWorkingTime(storeId: string, specialWorkingTime: StoreSpecialWorkingTime) {
    const url = `${this.url}/${storeId}/special-working-hours`;
    const requestBody: AddStoreSpecialWorkingHoursRequest = {
      date: specialWorkingTime.startDate,
      workingHours: {
        openingTime: specialWorkingTime.workingTime.openingTime,
        closingTime: specialWorkingTime.workingTime.closingTime
      },
    };
    return this.http.post(url, requestBody);
  }

  /**
   * Edits special working time record for the given store.
   * @param storeId an identifier of a store.
   * @param specialWorkingTime special store working times.
   */
  editSpecialStoreWorkingTime(storeId: string, specialWorkingTime: StoreSpecialWorkingTime) {
    const url = `${this.url}/${storeId}/special-working-hours/${specialWorkingTime.startDate}`;
    const requestBody: EditStoreSpecialWorkingHoursRequest = {
      workingHours: {
        openingTime: specialWorkingTime.workingTime.openingTime,
        closingTime: specialWorkingTime.workingTime.closingTime
      },
    };
    return this.http.put(url, requestBody);
  }

  /**
   * Deletes a special working time record for the given store.
   * @param storeId an identifier of a store.
   * @param date teh date to be deleted.
   */
  deleteSpecialStoreWorkingTime(storeId: string, date: string) {
    const url = `${this.url}/${storeId}/special-working-hours/${date}`;
    return this.http.delete(url);
  }
}
